// extracted by mini-css-extract-plugin
export default {"root":"drop-overlay_root__J-rYM","content":"drop-overlay_content__0ra1B","icon":"drop-overlay_icon__S7BS+"};